// Module
var code = "<div class=\"sys-info-inner\"> <i class=\"icon fa-2x\" ng-class=\"vm.icon\"></i> <div class=\"info\"> <div class=\"white-space-nowrap\">{{ vm.name }}</div> <div class=\"white-space-nowrap\" style=\"overflow:hidden\">{{ vm.version }}</div> <div class=\"error\" style=\"overflow:hidden\">{{ vm.error }}</div> </div> </div> ";
// Exports
export default code;